import { fetchSubjects } from "../../utils/content/library";
import { receive_subject_content } from "../../reducers/SubjectContent/reducer";

/**
 * @param {string} subjects
 * @param {number} [pageSize]
 */
export const fetch_subject_content = (subjects, pageSize) => {
    return (dispatch) => {
        return fetchSubjects(subjects, pageSize).then((items) => {
            return dispatch(receive_subject_content({ subjects, items }));
        });
    };
};
